import { routes } from 'App'
import React, { useEffect } from 'react'
import LoginService from 'services/login-service'
import { pathToFileURL } from 'url'

function buildPath(authToken: string | null) {
  let path = `${process.env.REACT_APP_API_URL}${window.location.pathname.slice(
    '/intercept'.length
  )}`

  if (window.location.search) {
    path = `${path}${window.location.search}&access_token=${authToken}`
  } else {
    path = `${path}?access_token=${authToken}`
  }

  return path
}

//takes calls and sends them to whatever the search and path is after /inteceptor.
function APIInterceptor() {
  useEffect(() => {
    async function handleNavigate() {
      const token = await LoginService.getStoredAccessToken()
      if (!token) {
        window.location.href = window.location.origin
        return
      }

      const path = buildPath(token)

      window.location.href = path
    }

    handleNavigate()
  }, [])

  return null
}

export default APIInterceptor
